import React from "react";
import { Grid } from "@material-ui/core/";
import Aux from "../../../hoc/Auxilliary";
import ApplicationHomePage from "../../../components/Application/ApplicationHome/index";

const ApplicationHome=(props)=>{
  return(
    <Aux>
    <Grid container>
      <Grid item container xs={11} sm={10} style={{ margin: "0 auto" }}>
      <ApplicationHomePage {...props} />
      </Grid>
    </Grid>
  </Aux>
  )
}

export default ApplicationHome;